import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/business/")({
    beforeLoad: () => {
        throw redirect({ to: "/customers/success", replace: true });
    },
});
